const { APIGet } = require('utilities/APIRequestHelper');

const apiURLBuilder = require('core/apiURLBuilder');

const keysToCamelCaseDeep = require('utilities/keysToCamelCaseDeep');
const fetchFailed = require('./fetchFailed');
const fetchRequested = require('./fetchRequested');
const fetchSucceeded = require('./fetchSucceeded');
const fetchSubCategories = require('./fetchSubCategories');
const fetchMinimumDetails = require('./fetchMinimumDetails');
const fetchCatalogueDetails = require('./fetchCatalogueDetails');
// @commons
const i18nCommons = require('commonsUtilities/i18n').i18n;
const { ES_LANG } = require('constants/contactCenter/language');

const types = require('../../constants/actionTypes');
const {
    SEARCH_FUND_CATEGORY_PAGE_NUM,
    SEARCH_FUND_CATEGORY_SEARCH_LIMIT,
    LEGAL_DOCUMENTS_TYPES,
} = require('../../constants');

const mapIdType = idType => (
    {
        'isin': 'ISIN',
        'secid': 'SecId',
        'cisid': 'customInstitutionSecurityId',
    }[idType]
);


// Gets the selected language
const i18nLanguage = i18nCommons.getLanguage(false, ES_LANG);

/**
 * Complete response with camelcase keys and all of the ids.
 **/
const mapResponse = (response, { secId, isin, customInstitutionSecurityId }) => ({
    ...keysToCamelCaseDeep(response),
    secId,
    isin,
    customInstitutionSecurityId,
});

/**
 * Details must be searched by secid.
 **/
const fetchDetails = ({ secId, isin, customInstitutionSecurityId, originCountry }, dispatch) => {
    const requestData = {
        query: {
            viewId: 'fullNew',
            responseViewFormat: 'json',
        }
    };

    return APIGet(dispatch, apiURLBuilder.getURL('brokerGetMorningStarScreenerSecurityDetails', {type:'7ug1nla4nl', id:secId, originCountry:originCountry, languageId:i18nLanguage}), requestData)
    .then(
        response => dispatch(fetchSucceeded({ funds: response.map(r => mapResponse(r, { secId, isin, customInstitutionSecurityId })) })),
        error => dispatch(fetchFailed(error))
    );
};

const fetchWealthCatalogueDetails = ( isin, dispatch, isAlternativeFund) => {
    const requestData = {
        query: {
            text: isin,
            pageSize: 5,
            pageSizeGroup: 10,
            pageNumber: 1,
        }
    };

    return APIGet(dispatch, apiURLBuilder.getURL('catalogueBrokerAdvancedSearch'), requestData)
    .then(
        response => {
            if (isAlternativeFund) {
                dispatch(fetchCatalogueDetails(response.alternativeFunds))    
            } else {
                dispatch(fetchCatalogueDetails(response.funds))    
            }
        },
        error => dispatch(fetchFailed(error))
    );
}
/**
 * A fund can be searched by any id and allow us to know its secid.
 **/
const searchFund = ({ idType, id }, dispatch) => {
    const filtersMap = mapIdType(idType);
    const requestData = {
        query: {
            securityDataPoints: 'secId|isin|customInstitutionSecurityId',
            outputType: 'json',
            currency: 'EUR',
            universeIds: 'FOEUR$$ALL_2118',
            filters: `${filtersMap}:EQ:${id}`
        }
    };

    return APIGet(dispatch, apiURLBuilder.getURL('etfsProductAnotherService'), requestData)
    .then(
        response => response,
        error => dispatch(fetchFailed(error))
    );
};

const getCategorySubCategories = dispatch => {
    const requestData = {
        query: {
            pageSize: 500,
            outputType: 'json',
            languageId: 'es-ES',
            universeIds: 'FOEUR$$ALL_2118',
            filterDataPoints: 'CustomCategoryId'
        }
    };

    return APIGet(dispatch, apiURLBuilder.getURL('etfsProductAnotherService'), requestData)
    .then(
        response => dispatch(fetchSubCategories(response.filters[0][0].CustomCategoryId))
    );
}

const getMinimumDetails = (isin, dispatch) => {
    const requestData = {
        query: {
            currencyId: 'EUR',
            isinList: isin
        }
    };

    return APIGet(dispatch, apiURLBuilder.getURL('brokerGetFundsMinAmounts'), requestData)
    .then(
        response => dispatch(fetchMinimumDetails(response.response))
    );
}

const fetchFundCategory = response => ({
        type: types.FUNDS_FETCH_CATEGORY,
        payload: response,
});

const searchClassicFund = ({ idType, id, originCountry }) => (dispatch) => {
    searchFund({ idType, id }, dispatch)
        .then(
            response => {
                if(!response.rows[0]){
                    dispatch(fetchFailed("error"))
                } else {
                    const { secId, isin, customInstitutionSecurityId } = response.rows[0];
                    fetchDetails({ secId, isin, customInstitutionSecurityId, originCountry }, dispatch)
                    getMinimumDetails(isin, dispatch)
                    getCategorySubCategories(dispatch);
                    fetchWealthCatalogueDetails(isin, dispatch);
                }
            },
            error => dispatch(fetchFailed(error))
        );
};

const setClosePrice = (response, isin) => ({
    type: types.FUNDS_SET_CLOSE_PRICE,
    payload: {response, isin},
});

const fetchClosePrice = (isin, dispatch) => {
    const requestData = {
        query: {
            isin: isin
        }
    };

    return APIGet(dispatch, apiURLBuilder.getURL('brokerGetClosePrice'), requestData)
    .then(
        response => {
            dispatch(setClosePrice(response, isin))
        }
    )
}

const setAlternativeDocuments = payload => dispatch => {
    dispatch({
      type: types.FETCH_ALTERNATIVE_DOCUMENTS_SUCCESS,
      payload,
    });
  };

const fetchAlternativeFundsLegalDocuments = (isin, originCountry) => dispatch => {
    
    const { PROSPECTUS, INFORME_SEMESTRAL, DFI, PRESENTATION } = LEGAL_DOCUMENTS_TYPES;
    const fetchToLegalDocs = ['Prospectus', 'informeSemestral', 'DFI'];
  
    const onBucketDocs = {
        [PRESENTATION]:`${__PUBLIC_URL__}/assets2/wealth/fondos/presentacion/${isin}.pdf`
    }

    const getURL = (isin, originCountry, documentType) =>
      apiURLBuilder.getURL('allFundsLegalDocuments', {
        isin,
        documentType,
        originCountry,
      });
  
    const getAlternativeDocuments = (isin, originCountry, documentType) => {
      APIGet(dispatch, getURL(isin, originCountry, documentType), {})
        .then(({ documents }) => {
          const kindOfDocument = {
              [PROSPECTUS]: ['PR'],
              [INFORME_SEMESTRAL]: ['SAR'],
              [DFI]: ['PRP', 'KID'],
          };
  
          const getDocument = documents => {
            const validDocs = [];
            kindOfDocument[documentType].forEach(kind => {
              const doc = documents.find(document => document.kind === kind);
              if (doc) {
                validDocs.push(doc);
              }
            });
            return validDocs[0] ? validDocs[0].url : '';
          };
  
          if (documents) {
            const document = getDocument(documents);
            dispatch(setAlternativeDocuments({ isin:isin, documents: {[documentType]: document, ...onBucketDocs }}));
          }
        })
        .catch(error => {
        dispatch(setAlternativeDocuments({ isin:isin, documents: onBucketDocs }));
        // eslint-disable-next-line no-console
        console.error("Could not get documents: " + error);
        });
    };
  
    fetchToLegalDocs.forEach(documentType => {
      getAlternativeDocuments(isin, originCountry, documentType);
    });
  
  };



const searchProductCategory = (id, idType, originCountry, isPublicUser, isAlternativeFund) => dispatch => {
    const requestData =  isPublicUser ? undefined : ({
        query: {
            text: id,
            pageSize: SEARCH_FUND_CATEGORY_SEARCH_LIMIT,
            pageNumber: SEARCH_FUND_CATEGORY_PAGE_NUM
        }
    });
        
    const url = isPublicUser ? apiURLBuilder.getURL('catalogueBrokerSimpleSearchPublic', { isin: id, originCountry }) : apiURLBuilder.getURL('catalogueBrokerSimpleSearch');
    return APIGet(dispatch, url, requestData)
        .then(response => {
            if (isAlternativeFund) {
                fetchWealthCatalogueDetails(id, dispatch, isAlternativeFund);
                dispatch(fetchAlternativeFundsLegalDocuments(id, originCountry))
                dispatch(fetchSucceeded({ funds: [response.alternativeFunds.instrumentsList[0]]}))
                fetchClosePrice(response.alternativeFunds.instrumentsList[0].isin, dispatch)
            } else {
                dispatch(searchClassicFund({ idType, id, originCountry }));
            }
        })
}



const fetched = ({ idType, id, originCountry, isPublicUser = false, isAlternativeFund = false  }) => (dispatch) => {
    dispatch(fetchRequested({ id, idType }));
    dispatch(searchProductCategory(id, idType, originCountry, isPublicUser, isAlternativeFund));
};


module.exports = fetched;